/**
 * Created by tomers on 6/17/2017.
 */
define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var template = require("templates/top-level-menu/topLevelMenuCustomReasonItem.tmpl");

    var TopLevelMenuCustomReasonItemView = Marionette.ItemView.extend({
        className: "top-level-menu-custom-reason-item",
        template: template,
        events: {
            "click": "_onCustomReasonItemClick"
        },

        customTemplateHelpers: function() {
            return {
                iconClassName: this.iconClassName
            };
        },

        initialize: function(options) {
            this.iconClassName = options.iconClassName;
        },

        onRender: function() {
            this._updateSelectedClass();
        },

        _updateSelectedClass: function() {
            this.$el.toggleClass("selected", this.model.get("selected"));
        },

        _onCustomReasonItemClick: function(e) {
            e.stopPropagation();

            this.trigger("click", e);
        }
    });

    return TopLevelMenuCustomReasonItemView;
});
